'use client';

import Link from 'next/link';
import { Container } from '@/components/ui/container';
import { SearchBox } from '@/components/search-box';
import { UserMenu } from './navbar/user-menu';
import { CartIcon } from '@/modules/cart/components/cart-icon';
import { useUser as useClerkUser } from '@clerk/nextjs';

export function Header() {
  const { isLoaded, user: clerkUser } = useClerkUser();
  return (
    <header className="sticky top-0 z-50 w-full border-b bg-background/95 backdrop-blur supports-[backdrop-filter]:bg-background/60">
      <Container>
        {/* Main header row - always shows logo, cart, and user menu */}
        <div className="flex h-16 items-center justify-between">
          <div className="flex items-center">
            <Link href="/" className="font-bold text-xl lg:text-xl md:text-lg sm:text-base">
              FLASHPOINT COLLECTIBLES
            </Link>
          </div>

          {/* Cart and User Menu - ALWAYS VISIBLE at all breakpoints */}
          <nav className="flex items-center gap-4 md:gap-3 sm:gap-2">
            { clerkUser?.publicMetadata?.isAdmin ? <Link href="/admin">Admin</Link> : null}
            <CartIcon />
            <UserMenu />
          </nav>
        </div>

        <div className="border-t border-border/50">
          <div className="py-3">
            <SearchBox />
          </div>
        </div>
      </Container>
    </header>
  );
}
